import React from "react"

// Fixes cursor position on the edges of inline nodes in Chromium based browsers.
// Eg. when cursor is put at the end of the link, by default typing should not continue the link.
//
// See: https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
export const InlineChromiumBugfix = () => (
  <span contentEditable={false} style={{ fontSize: 0 }}>
    {String.fromCodePoint(160) /* Non-breaking space */}
  </span>
)
